import UnknownErrorIcon from '@/assets/svg/unknown-error.svg?react';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { ErrorCode } from '@/shared/constant/error/ErrorCode';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import clsx from 'clsx';
import React from 'react';

export type UnknownErrorProps = {
  value: ErrorCodeMessageType;
  className?: string;
};

export function UnknownError(props: UnknownErrorProps) {
  const { className, value } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  const errorMessage = React.useMemo(() => {
    if (value.errorCode === ErrorCode.Unknown) {
      return value.errorMessage;
    }

    return undefined;
  }, [value]);

  return (
    <div
      className={clsx(
        'flex w-auto flex-col items-center justify-center max-os:p-5 os:w-[480px]',
        className,
      )}
    >
      <UnknownErrorIcon />

      <div className="align-center mt-8 flex justify-center text-center text-2xl font-semibold text-color">
        {clientI18n('message.scriptError.checkNetworkOrContactStaff')}
      </div>

      {!!errorMessage && (
        <div className="align-center mt-2 text-lg font-400 text-secondary">{errorMessage}</div>
      )}
    </div>
  );
}
